import React from 'react';
import { useEstabFormContext } from './Context';
import PhoneNumber from '../../../../components/inputs/PhoneNumber';
import { SettingsRow, SettingsSection } from './SettingsGroup';

export function ContatoEstabelecimento() {
    const {
        phoneNumber,
        setPhoneNumber,
        isPhoneNumberWhatsapp,
        setIsPhoneNumberWhatsapp,
        instagram,
        setInstagram,
        facebook,
        setFacebook,
        twitter,
        setTwitter,
    } = useEstabFormContext();

    return (
        <div className="grid gap-6 xl:grid-cols-2 xl:items-start">
            <SettingsSection
                title="Telefone"
                footer="Com WhatsApp ativo, confirmações e mensagens automáticas são enviadas por este número. A mensagem fica na aba WhatsApp."
            >
                <SettingsRow label="Número" htmlFor="phone">
                    <PhoneNumber
                        value={phoneNumber}
                        setValue={setPhoneNumber}
                        label="Número de telefone"
                        hideLabel
                        placeholder="+55 (00) 0 0000-0000"
                        inputClassName="input estab-field"
                    />
                </SettingsRow>
                <SettingsRow label="Usar como WhatsApp" htmlFor="isPhoneNumberWhatsapp" inline>
                    <input
                        id="isPhoneNumberWhatsapp"
                        type="checkbox"
                        className="toggle toggle-success"
                        checked={isPhoneNumberWhatsapp}
                        onChange={() => setIsPhoneNumberWhatsapp(!isPhoneNumberWhatsapp)}
                    />
                </SettingsRow>
            </SettingsSection>

            <SettingsSection title="Redes sociais" footer="Informe o link completo do perfil.">
                <SettingsRow label="Instagram" htmlFor="instagram">
                    <input
                        type="url"
                        id="instagram"
                        value={instagram}
                        onChange={(e) => setInstagram(e.target.value)}
                        className="input estab-field"
                        placeholder="https://instagram.com/..."
                    />
                </SettingsRow>
                <SettingsRow label="Facebook" htmlFor="facebook">
                    <input
                        type="url"
                        id="facebook"
                        value={facebook}
                        onChange={(e) => setFacebook(e.target.value)}
                        className="input estab-field"
                        placeholder="https://facebook.com/..."
                    />
                </SettingsRow>
                <SettingsRow label="X (Twitter)" htmlFor="twitter">
                    <input
                        type="url"
                        id="twitter"
                        value={twitter}
                        onChange={(e) => setTwitter(e.target.value)}
                        className="input estab-field"
                        placeholder="https://x.com/..."
                    />
                </SettingsRow>
            </SettingsSection>
        </div>
    );
}
